import controller from './venue-hours-manage.controller';
import template from './venue-hours-manage.html';
import './venue-hours-manage.less';

const component = {
    template,
    bindings: {
        isEdit: '<?',
    },
    controller: [
        '$state',
        '$uibModal',
        'crConfig',
        'crConstants',
        'crEntityService',
        'crNavigationService',
        'crAnalyticsService',
        'crErrorLoggingService',
        'crLocaleService',
        controller,
    ],
};

export default component;
